import React, { useState, useRef } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";

import { useUiFeedback } from "../../../context/ui-feedback/ui-feedback";
import {
  createWaiting,
  closeWaiting,
  createErrorFeedback,
  createSuccessFeedback,
} from "../../../context/ui-feedback/action";
import { PageLayout } from "../../common/page-layout/page-layout";
import { useCreateServiceWorksheet } from "../../../api/service-worksheet-api";

export const NewServiceWorksheet = () => {
  const createServiceWorksheet = useCreateServiceWorksheet();
  const intl = useIntl();
  const navigate = useNavigate();

  const { uiFeedbackDispatch } = useUiFeedback();

  const worksheetFormRef = useRef(null);
  const [formValidated, setFormValidated] = useState(false);
  const [number, setNumber] = useState("");

  const buildPaths = () => {
    return [
      {
        link: "/",
        title: intl.formatMessage({ id: "page.welcome.title" }),
      },
      {
        link: "/serviceworksheets",
        title: intl.formatMessage({ id: "page.serviceworksheets.title" }),
      },
    ];
  };

  const onSubmitCreateServiceWorksheet = async (event) => {
    event.preventDefault();
    setFormValidated(true);
    if (worksheetFormRef.current.checkValidity()) {
      createWaiting(uiFeedbackDispatch);
      try {
        await createServiceWorksheet(number, (data) => {
          if (data instanceof Error) {
            throw data;
          } else {
            createSuccessFeedback(
              uiFeedbackDispatch,
              intl.formatMessage({
                id: "page.newserviceworksheet.success.create",
              }),
            );
            navigate(`/editserviceworksheet/${data.id}`);
          }
        });
      } catch (ex) {
        if (ex.response?.status === 401 || ex.response?.status === 403) {
          navigate("/");
        } else {
          createErrorFeedback(
            uiFeedbackDispatch,
            intl.formatMessage({
              id: "page.newserviceworksheet.exception.create.title",
            }),
            intl.formatMessage({
              id: "page.newserviceworksheet.exception.create.description",
            }),
          );
        }
      } finally {
        closeWaiting(uiFeedbackDispatch);
      }
    }
  };

  return (
    <PageLayout
      paths={buildPaths()}
      title={intl.formatMessage({ id: "page.newserviceworksheet.title" })}
    >
      <Form
        ref={worksheetFormRef}
        validated={formValidated}
        onSubmit={onSubmitCreateServiceWorksheet}
      >
        <Form.Group className="mb-3">
          <Form.Label>
            <FormattedMessage id="data.serviceworksheet.form.salesorder.number.label" />
          </Form.Label>
          <Form.Control
            type="text"
            placeholder={intl.formatMessage({
              id: "data.serviceworksheet.form.salesorder.number.placeholder",
            })}
            value={number}
            required
            onChange={(event) => {
              setNumber(event.target.value);
            }}
          />
        </Form.Group>
        <Button
          className="me-2"
          variant="primary"
          onClick={(event) => onSubmitCreateServiceWorksheet(event)}
        >
          <FormattedMessage id="page.newserviceworksheet.button.create" />
        </Button>
      </Form>
    </PageLayout>
  );
};
